import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { LoaderRing } from 'components/LoaderRing';
import { ButtonContainer, FileOptionsContainer, OptionsButtonContainer } from '../../styles';
import { Button } from 'components';
import { colors } from 'styles/colors';
import { File6Icon } from '~/icons';
import { FileButton } from '../FileButton';

interface FileOptionsProps {
  error: boolean;
  file: File;
  loading: boolean;
  onClickCancel: () => void;
  onClickSubmit: () => void;
  onClickResendFile: (file: File) => void;
}

export function FileOptions({
  error,
  file,
  loading,
  onClickCancel,
  onClickSubmit,
  onClickResendFile,
}: Readonly<FileOptionsProps>): ReactElement {
  const { t } = useTranslation();

  function formatNameString(name: string): string {
    if (name.length > 30) {
      const [, format] = name.split('.');
      return `${name.slice(0, 30)}... .${format}`;
    }

    return name;
  }

  function renderSubmitButtonLabel(): ReactElement | string {
    return loading ? (
      <LoaderRing size="small" />
    ) : t('simEnviarArquivo');
  }

  return (
    <FileOptionsContainer>
      <Button
        type="button"
        variant="neutral-stroke-primary"
        onClick={() => { }}
        style={{
          height: '27px',
          pointerEvents: 'none',
          cursor: 'default',
          ...(error && {
            borderColor: colors.stroke['danger-base'],
            color: colors.text['danger-base'],
          }),
        }}
      >
        <ButtonContainer>
          <File6Icon color={error ? colors.icon['danger-base'] : undefined} />
          <span>{formatNameString(file.name)}</span>
        </ButtonContainer>
      </Button>
      <OptionsButtonContainer>
        {error ? (
          <FileButton onChangeFile={onClickResendFile} />
        ) : (
          <Button
            type="button"
            variant="primary-filled"
            onClick={loading ? () => { } : onClickSubmit}
          >
            {renderSubmitButtonLabel()}
          </Button>
        )}
        <Button
          type="button"
          variant="neutral-ghost"
          onClick={onClickCancel}
          disabled={loading}
        >
          {t('cancelar')}
        </Button>
      </OptionsButtonContainer>
    </FileOptionsContainer>
  );
}
